import styled from 'styled-components';

interface ISelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

export const Select = styled.select<ISelectProps>`
  width: 100%;
  height: 40px;
  padding-left: 15px;
  font: 14px EffraRegular;
`;
export const Option = styled.option``;
